import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {TableRecordResult} from "../../model/api/table-record-result";
import {Observable} from "rxjs";
import {CrystalclearClearingBackUrl} from "../config/crystalclear-clearing-back-url";
import {ClearingInfoLoadRequest} from "../../model/clearing/clearing-info-load-request";
import {ApiValidation} from "../../model/api/api-validation";
import {SyncMetadata} from "../../model/api/sync-metadata";
import {ClearingSelectionInfo} from "../../model/clearing/clearing-selection-info";
import {ClearingSelectionSummary} from "../../model/clearing/clearing-selection-summary";

@Injectable({
  providedIn: 'root'
})
export class ClearingTradeInfoService extends ParentAPIService implements OnInit, OnDestroy {


  constructor(http: HttpClient) {
    super(http);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public getSelectionSummary(request: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionSummary[]>> {
    request.selectionBase = true;
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_TRADE_INFO_SELECTION_SUMMARY, request);
  }

  public getSelectionInfoLegs(request: ClearingInfoLoadRequest): Observable<ApiValidation<ClearingSelectionInfo[]>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_TRADE_INFO_SELECTION_INFO_LEGS, request);
  }

  public getTradeAllocationApproval(request: ClearingInfoLoadRequest): Observable<ApiValidation<any>> {
    return this.post(CrystalclearClearingBackUrl.TRADE_ALLOCATION_APPROVAL, request);
  }
}
